/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IReportsConstructorSlice } from './types';

const initialConstructorState: IReportsConstructorSlice = {
    selectedItem: null,
    currentRowItem: null,
    templatesData: {
        elements: [],
        count: 0,
        page: 0,
    },
};

export const constructorSlice = createSlice({
    name: 'reportsConstructor',
    initialState: initialConstructorState,
    reducers: {
        setSelectedItem(state, action: PayloadAction<IReportsConstructorSlice['selectedItem']>) {
            state.selectedItem = action.payload;
        },
        setCurrentRowItem(state, action: PayloadAction<IReportsConstructorSlice['currentRowItem']>) {
            state.currentRowItem = action.payload;
            state.selectedItem = action.payload ? action.payload.selectedItem : null;
        },
        setTemplatesData(state, { payload }: PayloadAction<IReportsConstructorSlice['templatesData']>) {
            state.templatesData.page = payload.page;
            state.templatesData.elements =
                payload.page === 0 ? payload.elements : state.templatesData.elements.concat(payload.elements);
            state.templatesData.count = payload.count;
        },
        setTempaltesPage(state, { payload }: PayloadAction<number>) {
            state.templatesData.page = payload;
        },
    },
});

export const { setSelectedItem, setCurrentRowItem, setTemplatesData, setTempaltesPage } = constructorSlice.actions;
